import { useEffect } from 'react';
import { compose } from '@reduxjs/toolkit';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Error from 'core/errors/Error';
import Button from 'core/buttons/Button';
import withAppState from 'hoc/withAppState';
import PageContent from 'layouts/PageContent';
import PartnerCountries from 'components/partner-countries/PartnerCountries';
import PartnerCountryFilterValues from 'components/partner-countries/PartnerCountryFilterValues';
import { resetGetPartnerCountriesFailure } from 'app/features/partner-countries/partnerCountrySlice';
import PartnerCountryBriefDetailsModal from 'components/partner-countries/PartnerCountryBriefDetailsModal';

import Auth from 'utils/Auth';

import { buildRoute } from 'routes';
import { permissions } from 'app/data/permissions';
import { HasPermission } from 'hoc/withRole';

function ListPartnerCountry({ isNetworkError }) {
  const partnerCountryState = useSelector((state) => state.partnerCountries.index);

  const { isError, errorCode } = partnerCountryState;

  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    if (isError) dispatch(resetGetPartnerCountriesFailure());
  }, [isNetworkError]);

  if (isError)
    return (
      <Error
        status={errorCode}
        withInDashboard={true}
        onRetry={() => dispatch(resetGetPartnerCountriesFailure())}
      />
    );

  return (
    <PageContent
      title={Auth.isSuperAdmin() ? 'Partner Countries' : 'Countries'}
      rightTopEndContent={
        <HasPermission permission={permissions.CREATE_PARTNER_COUNTRY}>
          <Button
            onClick={() => navigate(buildRoute('partner-countries.create'))}
            color="primary"
            startIcon={<AddIcon />}
          >
            Add Partner Country
          </Button>
        </HasPermission>
      }
    >
      <PartnerCountryFilterValues />
      <PartnerCountries />
      <PartnerCountryBriefDetailsModal />
    </PageContent>
  );
}

export default compose(withAppState)(ListPartnerCountry);
